import { Button } from '@crazyegginc/hatch';
import { Modal } from '/src/contexts/modal';

import { ReactComponent as CeBalloonIcon } from '@crazyegginc/hatch/dist/images/logo-ce-balloon.svg';
import { ReactComponent as GoogleAnalyticsIcon } from '@crazyegginc/hatch/dist/images/logo-google-analytics.svg';
import { ReactComponent as DotsIcon } from '@crazyegginc/hatch/dist/images/icon-menu-dots.svg';
import { ReactComponent as ExternalIcon } from '@crazyegginc/hatch/dist/images/icon-open-url-outline.svg';
import { useCallback } from 'react';

export function ConfirmRedirectModal() {
  const googleAnalyticsRedirect = useCallback(() => {
    const redirectUrl = `${encodeURIComponent(window.location.href)}&referrer=google_analytics`;
    window.location.href = `${window.AUTH_API_URL}/ga/import?redirect_to=${redirectUrl}`;
  }, []);

  return (
    <Modal dialogClassName="w-[578px] flex flex-col items-center p-[30px]">
      <div className="flex items-center justify-center space-x-3 mb-5">
        {/* Balloon icon */}
        <div className="w-16 h-16 rounded border border-mystic-500 flex items-center justify-center">
          <CeBalloonIcon className="w-10 h-10 fill-current text-lima-500" />
        </div>

        {/* Dots */}
        <DotsIcon className="w-16 h-16 rotate-90 fill-current text-cadet-blue-500" />

        {/* GA icon */}
        <div className="w-16 h-16 rounded border border-mystic-500 flex items-center justify-center">
          <GoogleAnalyticsIcon className="w-10 h-10" />
        </div>
      </div>

      <h2 className="text-header-2 mb-6">Connect Google Analytics</h2>

      <div className="border border-mystic-500 rounded w-full p-4 divide-y divide-mystic-500 mb-6">
        <div className="pb-4">
          <h3 className="text-body-1">This page will redirect to Google</h3>
          <span className="text-body-2">You’ll sign in and confirm permissions on Google’s page.</span>
        </div>
        <div className="pt-4">
          <h3 className="text-body-1">Private and secure</h3>
          <span className="text-body-2">Your Google Analytics data is used only to proivde relevant insights.</span>
        </div>
      </div>

      <Button className="w-full !h-10 flex items-center justify-center space-x-2" onClick={googleAnalyticsRedirect}>
        <span>Continue to Google</span>
        <ExternalIcon className="fill-current text-white w-3 h-3" />
      </Button>
    </Modal>
  );
}
